/*
 *
 * QualitativeQuestionList constants
 *
 */

export const GET_QUALITATIVE_ANSWERS_WATCHER =
  "app/QualitativeQuestionList/GET_QUALITATIVE_ANSWERS_WATCHER"
export const GET_QUALITATIVE_ANSWERS_SUCCESS =
  "app/QualitativeQuestionList/GET_QUALITATIVE_ANSWERS_SUCCESS"
export const GET_QUALITATIVE_ANSWERS_FAILED =
  "app/QualitativeQuestionList/GET_QUALITATIVE_ANSWERS_FAILED"
